<template>
  <div class="hover07">
    <figure class="banner">
      <v-parallax class="img" :src="require('@/assets/images/portada2.png')">
      </v-parallax>
      <div class="title-parallax">
        <p data-aos="zoom-in" data-aos-delay="1000">4 años y 8 meses</p>
      </div>
    </figure>
  </div>
</template>

<script>
  export default {
    name:'banner'
  }
</script>

<style lang="scss" scoped>
figure {
	margin: 0;
	padding: 0;
	background: #fff;
	overflow: hidden;
  position: relative;
}
.img{
  // transform: translate(-50%, 200px);
   @media screen and (max-width:960px){
     height: 250px !important;

   }
}
.v-parallax__image{
  @media screen and (max-width:960px){
     transform:none !important;
     max-height: 100% !important;
   }
}
.hover07 figure .img {
	-webkit-filter: blur(4px);
	filter: blur(4px);
}
.title-parallax{
  position: absolute;
  top:0;
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
  align-items: center;
  & p{
    text-align: center;
    font-family: 'Amatic SC', cursive;
    font-size:5rem;
    font-weight:700;
    @media screen and (max-width:960px){
     font-size:3rem;
   }
  }
}
</style>